import BuildIcon from '@mui/icons-material/Build';
import InfoIcon from '@mui/icons-material/Info';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsIcon from '@mui/icons-material/Settings';
import { BoardTypes, Bumps, Material, Settings, Theme, Units } from 'Types';

export const ALLOW_WHEN_POPOVER_OPEN = 'allow-when-popover-open';

export const EMPTY_RECT = { top: 0, left: 0, height: 0, width: 0 };

export const MaterialNames: Record<Material, string> = {
  [Material.A]: 'Ash',
  [Material.B]: 'Beech',
  [Material.BL]: 'Bloodwood',
  [Material.BU]: 'Bubinga',
  [Material.BY]: 'Birch (Yellow)',
  [Material.C]: 'Cherry',
  [Material.CH]: 'Chechen',
  [Material.J]: 'Jatoba',
  [Material.M]: 'Maple',
  [Material.P]: 'Padauk',
  [Material.PH]: 'Purple Heart',
  [Material.S]: 'Sapele',
  [Material.W]: 'Walnut',
  [Material.WE]: 'Wenge',
  [Material.YH]: 'Yellow Heart',
  [Material.Z]: 'Zebrawood',
};

const MaterialCosts: Record<Material, number> = {
  [Material.A]: 6,
  [Material.B]: 6,
  [Material.BL]: 20,
  [Material.BU]: 10,
  [Material.BY]: 6,
  [Material.C]: 7,
  [Material.CH]: 20,
  [Material.J]: 7,
  [Material.M]: 6.5,
  [Material.P]: 10.35,
  [Material.PH]: 10,
  [Material.S]: 6.5,
  [Material.W]: 11.4,
  [Material.WE]: 16.65,
  [Material.YH]: 10,
  [Material.Z]: 20,
};

export const DEFAULT_SETTINGS: Settings = {
  theme: Theme.System,
  kerf: 0.125,
  planeBuffer: 0.175,
  units: Units.IN,
  waste: 0.2,
  metric: false,
  pxPerInch: 24,
  random: {
    styles: BoardTypes,
    materials: [Material.M, Material.W, Material.WE, Material.PH, Material.C],
    size: {
      height: 16,
      width: 12,
    },
  },
  leftNavCollapsed: false,
  presetsCollapsed: false,
  customCollapsed: false,
  materialsCollapsed: false,
  detailsCollapsed: false,
  materialCosts: {
    [Material.A]: {
      price: MaterialCosts[Material.A],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.B]: {
      price: MaterialCosts[Material.B],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.BL]: {
      price: MaterialCosts[Material.BL],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.BU]: {
      price: MaterialCosts[Material.BU],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.BY]: {
      price: MaterialCosts[Material.BY],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.C]: {
      price: MaterialCosts[Material.C],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.CH]: {
      price: MaterialCosts[Material.CH],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.J]: {
      price: MaterialCosts[Material.J],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.M]: {
      price: MaterialCosts[Material.M],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.P]: {
      price: MaterialCosts[Material.P],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.PH]: {
      price: MaterialCosts[Material.PH],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.S]: {
      price: MaterialCosts[Material.S],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.W]: {
      price: MaterialCosts[Material.W],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.WE]: {
      price: MaterialCosts[Material.WE],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.YH]: {
      price: MaterialCosts[Material.YH],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
    [Material.Z]: {
      price: MaterialCosts[Material.Z],
      boardUnit: 'fbm',
      costUnit: 'USD',
    },
  },
};

export const TITLE = 'Cutting Board Designer';

export const NAV_ITEMS = [
  { label: 'Designer', to: '/designer', Icon: BuildIcon },
  { label: 'About', to: '/about', Icon: InfoIcon },
  { label: 'Support Us', to: '/support-us', Icon: PaymentIcon },
];

export const SETTINGS_NAV_ITEM = {
  label: 'Settings',
  to: '/settings',
  Icon: SettingsIcon,
};

export const SIDEBAR_WIDTH = 300;
export const DRAWER_BREAKPOINT = 760;

export const BUMPS_BY_UNITS: Record<Units, Bumps> = {
  [Units.IN]: { bump: 0.125, shiftBump: 1 },
  [Units.MM]: { bump: 1, shiftBump: 10 },
};
